import { Rocket, ClipboardCheck, Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES, CHECKLIST } from "@/data/content";

export default function Future() {
  return (
    <section id="rehber" className="bg-white py-14 lg:py-16">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-6">
        {/* Geleceğin Fırsatları */}
        <Reveal>
          <div className="relative h-full rounded-2xl border border-slate-200 overflow-hidden bg-brand-light/40">
            <img
              src={IMAGES.greenFuture}
              alt=""
              aria-hidden
              className="absolute left-0 top-0 h-full w-40 object-cover opacity-15"
            />
            <div className="relative p-8 lg:p-10">
              <div className="flex items-center gap-3 mb-5">
                <span className="grid place-items-center w-12 h-12 rounded-xl bg-brand text-white">
                  <Rocket className="w-6 h-6" strokeWidth={1.8} />
                </span>
                <h3 className="font-extrabold text-navy text-2xl tracking-tight">GELECEĞİN FIRSATLARI</h3>
              </div>
              <p className="text-slate-600 leading-relaxed">
                Türkiye'nin genç nüfusu, büyüyen ekonomisi, teknoloji şirketlerinin artışı ve
                sürdürülebilir finans uygulamaları, Borsa İstanbul'un önümüzdeki yıllarda da
                yatırımcılar için önemli fırsatlar sunmaya devam edeceğini göstermektedir.
              </p>
              <p className="text-slate-600 leading-relaxed mt-4">
                Yapay zekâ, savunma sanayi, enerji, teknoloji, finans, sağlık ve yeşil dönüşüm
                alanlarında faaliyet gösteren şirketler, Türkiye sermaye piyasalarının geleceğini
                şekillendiren önemli aktörler arasında yer almaktadır.
              </p>
            </div>
          </div>
        </Reveal>

        {/* Yatırıma Başlamadan Önce */}
        <Reveal delay={1}>
          <div className="relative h-full rounded-2xl border border-slate-200 overflow-hidden bg-brand-light/40">
            <img
              src={IMAGES.tradingScreen}
              alt=""
              aria-hidden
              className="absolute right-0 top-0 h-full w-40 object-cover opacity-15"
            />
            <div className="relative p-8 lg:p-10">
              <div className="flex items-center gap-3 mb-6">
                <span className="grid place-items-center w-12 h-12 rounded-xl bg-brand text-white">
                  <ClipboardCheck className="w-6 h-6" strokeWidth={1.8} />
                </span>
                <h3 className="font-extrabold text-navy text-2xl tracking-tight">YATIRIMA BAŞLAMADAN ÖNCE</h3>
              </div>
              <ul className="space-y-3.5">
                {CHECKLIST.map((c, i) => (
                  <li key={i} className="flex items-start gap-3 text-slate-700">
                    <span className="grid place-items-center w-5 h-5 rounded-full bg-green-100 text-green-600 shrink-0 mt-0.5">
                      <Check className="w-3 h-3" strokeWidth={3} />
                    </span>
                    <span className="leading-relaxed">{c}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
